// extracted by mini-css-extract-plugin
module.exports = {"privacy":"Privacy_privacy__1VCCu","privacy__content":"Privacy_privacy__content__23L6T","privacy__foot":"Privacy_privacy__foot__30tU6"};